import * as React from 'react';
import { IDropDownMenuProps } from '../../../DropDownMenu.types';
import DropDownMenuBase from '../../DropDownMenuBase';
import ArrowRightMenuButtonNSkin from '../../../../MenuButton/viewer/skinComps/ArrowRightMenuButtonNSkin/ArrowRightMenuButtonNSkin';
import styles from './ArrowRightMenuButtonSkin.scss';

const ArrowRightMenuButtonSkin: React.FC<IDropDownMenuProps> = props => {
  return (
    <DropDownMenuBase
      {...props}
      styles={styles}
      Button={ArrowRightMenuButtonNSkin}
    />
  );
};

export default ArrowRightMenuButtonSkin;
